import { BooleanCompare } from "@redotech/redo-customer-segments-common/segments/segment-where-condition-zod-schema";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { memo } from "react";
import { SegmentBuilderText } from "../segment-builder-text";
import {
  PresenceAwareOperatorSelect,
  PresenceOperators,
} from "./presence-operators";

const booleanOptions: RedoListItem<boolean>[] = [
  { id: "true", text: "true", type: "text", value: true },
  { id: "false", text: "false", type: "text", value: false },
];

export const BooleanFilter = memo(function BooleanFilter({
  comparison,
  setComparison,
  presence,
}: {
  comparison: BooleanCompare;
  setComparison: (condition: BooleanCompare) => void;
  presence?: PresenceOperators;
}) {
  return (
    <>
      {/* The presence operators read as "is set", so they supply their own verb. */}
      {!presence?.operator && <SegmentBuilderText>is</SegmentBuilderText>}
      <PresenceAwareOperatorSelect
        operator={comparison.value}
        operatorItems={booleanOptions}
        presence={presence}
        setOperator={(value) => setComparison({ ...comparison, value })}
      />
    </>
  );
});
